import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "./Footer";
import Header from "./Header";
import PlaneIco from "./assets/img/PlaneIco.png";
import TwoTickets from "./assets/img/TwoTickets.png";
import Travelator from "./assets/img/Travelator.png";
import Traveler from "./assets/img/Traveler.png";
import Suitcase from "./assets/img/Suitcase.png";
import LOWPRICECALENDER from "./assets/img/LOWPRICECALENDER.png";
import QRImg from "./assets/img/QRImg.png";
import giftImg from "./assets/img/giftImg.png";
import airlineImg from "./assets/img/airlineImg.png";
import { changeRequest, sendModificationRequest } from "../services/services";
import AirportSelector from "./AirportSelector";
import { toast } from "react-toastify";
import { toastCSS } from "../services/commonHandler";
const ManageBooking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bookingData = location.state?.bookingData;
  const [isSubmitting, setIsSubmitting] = useState(false);
  console.log(bookingData);

  const bookingDetails = JSON.parse(bookingData.searchData);
  console.log(bookingDetails);

  console.log("typeof searchData:", typeof bookingData.searchData);
  console.log(bookingData.uniqueTransId);
  useEffect(() => {
    if (bookingDetails?.Directions?.length > 0) {
      const firstDirection = bookingDetails.Directions[0][0];
      const firstSegment = firstDirection.Segments[0];

      setFromLocation(firstDirection.Origin || "");
      setToLocation(firstDirection.Destination || "");
      setDepartureDate(firstSegment.Departure?.split(" ")[0] || ""); // extract only date
      setReturnDate(
        bookingDetails.Directions.length > 1
          ? bookingDetails.Directions[1][0].Segments[0].Departure?.split(
              " "
            )[0] || ""
          : ""
      );
      setSeatClass(firstSegment.ServiceClass || "");
      setIsRoundTrip(bookingDetails.Directions.length > 1);

      // extract passenger count
      const adt =
        bookingDetails.PassengerFares?.find((p) => p.PassengerType === "ADT")
          ?.PassengerCount || 1;
      const chd =
        bookingDetails.PassengerFares?.find((p) => p.PassengerType === "CHD")
          ?.PassengerCount || 0;
      const inf =
        bookingDetails.PassengerFares?.find((p) => p.PassengerType === "INF")
          ?.PassengerCount || 0;
      setPassengerCounts({ adults: adt, children: chd, infants: inf });
    }
  }, []);

  const [isClosed, setIsClosed] = useState(false);
  const [showCancelBooking, setShowCancelBooking] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [showCancelBookingAuth, setShowCancelBookingAuth] = useState(false);
  const [showProceedToCancel, setShowProceedToCancel] = useState(false);
  const [show, setShow] = useState(false);
  const [showModifyBooking, setShowModifyBooking] = useState(false);
  const [modifyReason, setModifyReason] = useState("Other");
  const [modifyNotes, setModifyNotes] = useState("");
  // States to store pre-filled and modifiable form values
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [departureDate, setDepartureDate] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [seatClass, setSeatClass] = useState("");
  const [isRoundTrip, setIsRoundTrip] = useState(false);
  const [passengerCounts, setPassengerCounts] = useState({
    adults: 1,
    children: 0,
    infants: 0,
  });
  const [airports, setAirports] = useState([]);
  const [contact, setContact] = useState({
    email: bookingData.contact_info?.email || "",
    phone: bookingData.contact_info?.phone || "",
    phoneCountryCode: bookingData.contact_info?.phoneCountryCode || "",
  });

  const [passengers, setPassengers] = useState(
    bookingData.passenger_infos || []
  );
  console.log(passengers);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [reasonDetails, setReasonDetails] = useState({});
  const [showModifyReasonModal, setShowModifyReasonModal] = useState(false);
  const [flightChangeRequests, setFlightChangeRequests] = useState([]);
  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/mwgg/Airports/master/airports.json"
    )
      .then((res) => res.json())
      .then((data) => {
        const formatted = Object.values(data)
          .map((a) => ({
            city: a.city || a.name,
            iata: a.iata,
          }))
          .filter((a) => a.iata);
        setAirports(formatted);
      });
  }, []);

  // useEffect(() => {
  //     if (bookingDetails) {
  //       setFromLocation(bookingDetails.fromLocation || "");
  //       setToLocation(bookingDetails.toLocation || "");
  //       setDepartureDate(bookingDetails.departureDate || "");
  //       setReturnDate(bookingDetails.returnDate || "");
  //       setSeatClass(bookingDetails.seatClass || "");
  //       setIsRoundTrip(bookingDetails.isRoundTrip || false);
  //       setPassengerCounts(bookingDetails.passengerCounts || { adults: 1, children: 0, infants: 0 });
  //     }
  //   }, [bookingDetails]);
  const handleToggle = () => {
    setIsClosed(!isClosed);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleModifyReasonShow = () => setShowModifyReasonModal(true);
  const handleModifyReasonClose = () => {
    resetModifyRequestForm();
    setShowModifyReasonModal(false);
  };

  const handleDisclaimerClose = () => setShowDisclaimer(false);
  const handleDisclaimerShow = () => setShowDisclaimer(true);
  const handleCancelAuthClose = () => setShowCancelBookingAuth(false);
  const handleCancelAuthShow = () => {
    setShowDisclaimer(false);
    setShowCancelBookingAuth(true);
  };
  const handleProceedToCancelClose = () => setShowProceedToCancel(false);
  const handleProceedToCancelShow = () => {
    setShowCancelBookingAuth(false);
    setShowProceedToCancel(true);
  };
  const handleModifyBookingClose = () => setShowModifyBooking(false);
  const handleModifyBookingShow = () => setShowModifyBooking(true);
  const updatePassenger = (index, key, value) => {
    const updated = [...passengers];
    updated[index][key] = value;
    setPassengers(updated);
  };
  const isContactChanged =
    JSON.stringify(contact) !== JSON.stringify(bookingData.contact_info);
  const isPassengerChanged =
    JSON.stringify(passengers) !== JSON.stringify(bookingData.passenger_infos);
  const handleSelectReason = (reason) => {
    if (!selectedReasons.includes(reason)) {
      setSelectedReasons([...selectedReasons, reason]);
    }
  };

  const handleReasonDetails = (reason, value) => {
    setReasonDetails((prev) => ({ ...prev, [reason]: value }));
  };

  const removeReason = (reason) => {
    setSelectedReasons(selectedReasons.filter((r) => r !== reason));
    setReasonDetails((prev) => {
      const { [reason]: _, ...rest } = prev;
      return rest;
    });
  };

  const submitRequest = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const data = {
      bookingId: bookingData.bookingId,
      reasonType: selectedReasons,
      details: modifyNotes,
    };
    try {
      await changeRequest(
        data,
        (res) => {
          toast.success("Modification request sent successfully!", toastCSS);
          handleModifyBookingClose();
          handleModifyReasonClose();
          handleClose();
        },
        (err) => {
          toast.error("Failed to submit request.", toastCSS);
          console.error(err);
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetModifyRequestForm = () => {
    setSelectedReasons([]);
    setReasonDetails({});
  };
  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="digitalTicketWrap flightReservWrap manageBookingWrap">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-11">
                <div className="titleWrap">
                  <h2>Manage Booking</h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-10 col-md-11">
                {bookingDetails.Directions.map((directionGroup, idx) => {
                  const segmentList = directionGroup[0].Segments;
                  const firstSegment = segmentList[0];
                  const lastSegment = segmentList[segmentList.length - 1];
                  const airlineName =
                    directionGroup[0].PlatingCarrierName ||
                    firstSegment.Airline;
                  const travelClass = firstSegment.ServiceClass;
                  const baggage = firstSegment.Baggage?.[0]?.Amount || "N/A";

                  return (
                    <div className="manageBookBox" key={idx}>
                      <div className="ticketBox">
                        <div className="leftWraps">
                          <div className="topTTl">
                            <h2>
                              {idx === 0
                                ? "Departure Summary"
                                : "Return Summary"}
                            </h2>
                          </div>
                          <div className="topTtlWrap">
                            <div className="title">
                              <div className="icoWrap">
                                <img
                                  src={airlineImg}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <h2>{airlineName}</h2>
                            </div>
                            <h6 className="note">
                              {bookingDetails.Refundable
                                ? "Refundable"
                                : "Non-refundable"}
                            </h6>
                            <p className="classTxt">
                              Travel Class: <span>{travelClass}</span>
                            </p>
                          </div>

                          <div className="trvelTicWrap">
                            <div className="leftWrap">
                              <ul>
                                <li>
                                  <div className="items mainItem">
                                    <div className="leftData">
                                      <h3>{firstSegment.Origin}</h3>
                                      <h5>
                                        {new Date(
                                          firstSegment.Departure
                                        ).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })}
                                      </h5>
                                    </div>
                                    <div className="rightData">
                                      <p>
                                        {new Date(
                                          firstSegment.Departure
                                        ).toDateString()}
                                      </p>
                                      <p>{firstSegment.OriginName}</p>
                                      <p>
                                        Terminal -{" "}
                                        {firstSegment.Details[0]
                                          ?.OriginTerminal || "N/A"}
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="items">
                                    <h4>
                                      {directionGroup[0].DirectionTotalTime}
                                    </h4>
                                    <div className="planeIcoWrap">
                                      <img
                                        src={PlaneIco}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="items mainItem">
                                    <div className="leftData">
                                      <h3>{lastSegment.Destination}</h3>
                                      <h5>
                                        {new Date(
                                          lastSegment.Arrival
                                        ).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })}
                                      </h5>
                                    </div>
                                    <div className="rightData">
                                      <p>
                                        {new Date(
                                          lastSegment.Arrival
                                        ).toDateString()}
                                      </p>
                                      <p>{lastSegment.DestinationName}</p>
                                      <p>
                                        Terminal -{" "}
                                        {lastSegment.Details[0]
                                          ?.DestinationTerminal || "N/A"}
                                      </p>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="rightWrap">
                              <ul>
                                <li>
                                  <p>Baggage</p>
                                  <h3>ADULT</h3>
                                </li>
                                <li>
                                  <p>Check-in</p>
                                  <h3>{baggage}Kg</h3>
                                </li>
                                <li>
                                  <p>Cabin</p>
                                  <h3>7Kg</h3>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="ticketinfoWrap">
                            <ul>
                              <li>
                                <img
                                  src={TwoTickets}
                                  alt=""
                                  className="img-fluid"
                                />
                                <p>
                                  Separate tickets booked together for cheaper
                                  price
                                </p>
                              </li>
                              <li>
                                <img
                                  src={Travelator}
                                  alt=""
                                  className="img-fluid"
                                />
                                <p>Change of Terminal</p>
                              </li>
                              <li>
                                <img
                                  src={Traveler}
                                  alt=""
                                  className="img-fluid"
                                />
                                <p>Self Transfer</p>
                              </li>
                              <li>
                                <img
                                  src={Suitcase}
                                  alt=""
                                  className="img-fluid"
                                />
                                <p>{baggage}kg</p>
                              </li>
                            </ul>
                          </div>

                          <div className="ticketBookBtmWrap">
                            <div className="btmNote">
                              <img
                                src={Traveler}
                                className="img-fluid"
                                alt=""
                              />
                              <p>
                                Sorry, extra check-in baggage allowance details
                                are not available currently from airline.
                              </p>
                            </div>
                            <div className="rightCtaWrap">
                              {/* <button className="btn" type="button" onClick={handleModifyBookingShow}>Modify</button> */}
                              {/* <button className="btn">Download Ticket</button> */}
                              <button
                                className="btn"
                                type="button"
                                onClick={handleModifyReasonShow}
                              >
                                Modify Booking
                              </button>
                              {/* <button
                                className="btn"
                                type="button"
                                onClick={handleShow}
                              >
                                Cancel booking
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>

      <Modal show={show} onHide={handleClose} className="CancelBookingPopup">
        <Modal.Header closeButton>
          <Modal.Title>Select Cancellation Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Could you please specify the reason for your flight cancellation?
          </p>
          <Form>
            <ul className="formList">
              <li>
                <div className="inputField selectWrap">
                  <Form.Select>
                    <option>Other</option>
                    <option>Personal Reasons</option>
                    <option>Health Issues</option>
                    <option>Travel Restrictions</option>
                  </Form.Select>
                </div>
              </li>
              <li>
                <div className="inputField">
                  <Form.Control
                    as="textarea"
                    placeholder="Provide additional details (optional)"
                  />
                </div>
              </li>
              <li>
                <div className="ctaWrap">
                  <Button className="btn" onClick={handleDisclaimerShow}>
                    Continue
                  </Button>
                  <p>Nevermind, I don’t want to cancel.</p>
                </div>
              </li>
            </ul>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showModifyReasonModal}
        onHide={handleModifyReasonClose}
        className="CancelBookingPopup manageBookingModPopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Request Booking Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="frmWrap">
            <div className="fieldWrap">
              <Form.Group className="formFiledsWrap">
                {[
                  "Date Changes",
                  "Time Changes",
                  "Passenger Name Correction",
                  "Destination or Route Change",
                  "Flight Class Upgrade",
                  "Seat Selection or Change",
                  "Meal Preferences",
                  "Additional Baggage",
                  "Adding Services",
                  "Refund or Cancellation",
                  "Frequent Flyer Details",
                  "Other",
                ].map((reason) => (
                  <Form.Check
                    key={reason}
                    type="checkbox"
                    id={reason}
                    label={reason}
                    checked={selectedReasons.includes(reason)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedReasons((prev) => [...prev, reason]);
                      } else {
                        setSelectedReasons((prev) =>
                          prev.filter((r) => r !== reason)
                        );
                      }
                    }}
                  />
                ))}
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>Additional Note</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Provide details (optional)"
                  value={modifyNotes}
                  onChange={(e) => setModifyNotes(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="ctaWrap">
              <Button
                className="btn"
                onClick={submitRequest}
                disabled={isSubmitting || selectedReasons.length === 0}
              >
                {isSubmitting ? "Sending..." : "Send Request"}
              </Button>
              <Button variant="btn btnBdr" onClick={handleModifyReasonClose}>
                Cancel
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDisclaimer}
        onHide={handleDisclaimerClose}
        className="CancelBookingPopup colSpacePopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Disclaimer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Modification requests are subject to ticket availability and refunds
            are dependent on airline cancellation policies. Please note that a
            modification request is not a guarantee of change. Our customer
            service team will reach out to you with the best possible solution.
          </p>
          <div className="btmCtaWrap">
            <Button onClick={handleCancelAuthShow}>Continue</Button>
            <p>Nevermind, I don’t want to cancel.</p>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCancelBookingAuth}
        onHide={handleCancelAuthClose}
        className="CancelBookingPopup colSpacePopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Please authenticate yourself by entering the email address linked to
            the PNR number
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="topDataWrap">
            <div className="bookingNum">
              <p>Booking Number</p>
              <h3>HDX54854215D</h3>
            </div>
            <div className="inputWrap">
              <label>Email/Phone Number</label>
              <Form.Control type="text" />
              <p>Invalid email/phone number</p>
            </div>
          </div>
          <div className="btmCtaWrap">
            <Button onClick={handleProceedToCancelShow}>Continue</Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showProceedToCancel}
        onHide={handleProceedToCancelClose}
        className="CancelBookingPopup colSpacePopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Please authenticate yourself by entering the OTP linked to the PNR
            number
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="topDataWrap">
            <div className="bookingNum">
              <p>Booking Number</p>
              <h3>HDX54854215D</h3>
            </div>
            <div className="inputWrap">
              <label>OTP</label>
              <Form.Control type="text" />
              <div className="errTxt">
                <p>Invalid OTP</p>
                <p className="clrBlack">Resend 00:00</p>
              </div>
            </div>
          </div>
          <div className="btmCtaWrap">
            <Link to="/ManageBookingCancel" className="btn">
              Proceed to Cancel
            </Link>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModifyBooking}
        onHide={handleModifyBookingClose}
        className="CancelBookingPopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Modify Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <ul className="formList">
              <li>
                <Form.Group>
                  <AirportSelector
                    label="From"
                    value={fromLocation}
                    onChange={setFromLocation}
                    options={airports}
                    onSelect={setFromLocation}
                  />
                </Form.Group>
              </li>
              <li>
                <Form.Group>
                  <AirportSelector
                    label="To"
                    value={toLocation}
                    onChange={setToLocation}
                    options={airports}
                    onSelect={setToLocation}
                  />
                </Form.Group>
              </li>
              <li>
                <Form.Group>
                  <Form.Label>Departure Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={departureDate}
                    onChange={(e) => setDepartureDate(e.target.value)}
                  />
                </Form.Group>
              </li>
              {isRoundTrip && (
                <li>
                  <Form.Group>
                    <Form.Label>Return Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={returnDate}
                      onChange={(e) => setReturnDate(e.target.value)}
                    />
                  </Form.Group>
                </li>
              )}
              <li>
                <Form.Group>
                  <Form.Label>Seat Class</Form.Label>
                  <Form.Select
                    value={seatClass}
                    onChange={(e) => setSeatClass(e.target.value)}
                  >
                    <option>Economy</option>
                    <option>Business</option>
                    <option>First</option>
                    <option>Premium Economy</option>
                  </Form.Select>
                </Form.Group>
              </li>
              <li>
                <Form.Group>
                  <Form.Label>Passenger Note</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Optional note"
                    value={modifyNotes}
                    onChange={(e) => setModifyNotes(e.target.value)}
                  />
                </Form.Group>
              </li>
              {/* Contact Info Section */}
              <li>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={contact.email}
                    onChange={(e) =>
                      setContact({ ...contact, email: e.target.value })
                    }
                  />
                </Form.Group>
              </li>
              <li>
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    value={contact.phone}
                    onChange={(e) =>
                      setContact({ ...contact, phone: e.target.value })
                    }
                  />
                </Form.Group>
              </li>
              <li>
                <Form.Group>
                  <Form.Label>Phone Country Code</Form.Label>
                  <Form.Control
                    type="text"
                    value={contact.phoneCountryCode}
                    onChange={(e) =>
                      setContact({
                        ...contact,
                        phoneCountryCode: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </li>

              {/* Dynamic Passenger Inputs */}
              {passengers.map((p, index) => (
                <li key={index}>
                  <Form.Group>
                    <Form.Label>Passenger {index + 1}</Form.Label>

                    <Form.Control
                      type="text"
                      placeholder="Passenger Type (e.g. ADT)"
                      value={p.passengerType}
                      onChange={(e) =>
                        updatePassenger(index, "passengerType", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Title (Mr/Ms)"
                      value={p.title}
                      onChange={(e) =>
                        updatePassenger(index, "title", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      value={p.firstName}
                      onChange={(e) =>
                        updatePassenger(index, "firstName", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      value={p.lastName}
                      onChange={(e) =>
                        updatePassenger(index, "lastName", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Select
                      value={p.gender}
                      onChange={(e) =>
                        updatePassenger(index, "gender", e.target.value)
                      }
                      className="mb-2"
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </Form.Select>

                    <Form.Control
                      type="date"
                      placeholder="Date of Birth"
                      value={p.dateOfBirth}
                      onChange={(e) =>
                        updatePassenger(index, "dateOfBirth", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Passport Number"
                      value={p.passportNumber}
                      onChange={(e) =>
                        updatePassenger(index, "passportNumber", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="date"
                      placeholder="Passport Expiry Date"
                      value={p.PassportExpireDate}
                      onChange={(e) =>
                        updatePassenger(
                          index,
                          "PassportExpireDate",
                          e.target.value
                        )
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Nationality (ISO code)"
                      value={p.nationality}
                      onChange={(e) =>
                        updatePassenger(index, "nationality", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Issuing Country"
                      value={p.issuingCountry}
                      onChange={(e) =>
                        updatePassenger(index, "issuingCountry", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Select
                      value={p.isWheelchair ? "true" : "false"}
                      onChange={(e) =>
                        updatePassenger(
                          index,
                          "isWheelchair",
                          e.target.value === "true"
                        )
                      }
                      className="mb-2"
                    >
                      <option value="false">Wheelchair Not Required</option>
                      <option value="true">Wheelchair Required</option>
                    </Form.Select>

                    <Form.Control
                      type="text"
                      placeholder="Phone Country Code"
                      value={p.phoneCountryCode}
                      onChange={(e) =>
                        updatePassenger(
                          index,
                          "phoneCountryCode",
                          e.target.value
                        )
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Phone"
                      value={p.phone}
                      onChange={(e) =>
                        updatePassenger(index, "phone", e.target.value)
                      }
                      className="mb-2"
                    />

                    <Form.Control
                      type="email"
                      placeholder="Email"
                      value={p.email}
                      onChange={(e) =>
                        updatePassenger(index, "email", e.target.value)
                      }
                      className="mb-2"
                    />
                  </Form.Group>
                </li>
              ))}

              <li>
                <div className="ctaWrap">
                  <Button
                    className="btn"
                    onClick={async () => {
                      const currentSearchData = {
                        fromLocation,
                        toLocation,
                        departureDate,
                        returnDate,
                        seatClass,
                        passengerCounts,
                        isRoundTrip,
                      };

                      const originalSearchData = {
                        fromLocation: bookingDetails.Directions[0][0].Origin,
                        toLocation: bookingDetails.Directions[0][0].Destination,
                        departureDate:
                          bookingDetails.Directions[0][0].Segments[0].Departure?.split(
                            " "
                          )[0],
                        returnDate:
                          bookingDetails.Directions?.[1]?.[0].Segments?.[0].Departure?.split(
                            " "
                          )[0] || "",
                        seatClass:
                          bookingDetails.Directions[0][0].Segments[0]
                            .ServiceClass,
                        isRoundTrip: bookingDetails.Directions.length > 1,
                        passengerCounts: {
                          adults:
                            bookingDetails.PassengerFares?.find(
                              (p) => p.PassengerType === "ADT"
                            )?.PassengerCount || 1,
                          children:
                            bookingDetails.PassengerFares?.find(
                              (p) => p.PassengerType === "CHD"
                            )?.PassengerCount || 0,
                          infants:
                            bookingDetails.PassengerFares?.find(
                              (p) => p.PassengerType === "INF"
                            )?.PassengerCount || 0,
                        },
                      };

                      const changedSearchData = {};
                      for (const key in currentSearchData) {
                        if (
                          JSON.stringify(currentSearchData[key]) !==
                          JSON.stringify(originalSearchData[key])
                        ) {
                          changedSearchData[key] = currentSearchData[key];
                        }
                      }

                      // TODO: fetch contact and passenger info from backend if not already available
                      // For now, manually fill 1 sample adult (improve with dynamic list)
                      const updatedPassengers = passengers;

                      const updatedContact = contact;

                      // if (Object.keys(changedSearchData).length === 0) {
                      //   alert("No search details changed.");
                      //   return;
                      // }

                      const data = {
                        BookingTransactionRef: bookingData.uniqueTransId,
                        reason: "Passenger correction",
                        notes: modifyNotes,
                        updatedSearchData: changedSearchData,
                        updatedPassengers,
                        updatedContact,
                      };

                      console.log("Modify Request Data =>", data);

                      await sendModificationRequest(
                        data,
                        (res) => {
                          toast.success("Modification request sent!", toastCSS);
                          handleModifyBookingClose();
                        },
                        (err) => {
                          toast.error("Failed to submit request.", toastCSS);
                          console.error(err);
                        }
                      );
                    }}
                  >
                    Submit Request
                  </Button>
                  <p>Nevermind, I don’t want to modify.</p>
                </div>
              </li>
            </ul>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ManageBooking;
